<template>
<div :class="['micad_formElement micad_formElement_submit',getType(type)]">
    <label class="micad_formElement_label">{{label}}</label>
    <div class="micad_formElement_control">
        <input type="submit" class="micad_formElement_control_input micad_formElement_button micad_formElement_primary" value="Submit" />
        <input type="submit" class="micad_formElement_control_input micad_formElement_button" value="Cancel" />
    </div>
    <div class="micad_formElement_message">{{message}}</div>
</div>
</template>

<script>
export default {
  name: 'Submit',
  data() {
    return {
      label: "Quisque tristique.",
      message: "Quisque tristique quis leo vitae luctus.",
    }
  },
  props: {
    type: String,
  },
  methods: {
   getType(type) {
    if (type !== undefined) {
        return ' micad_formElement_'+type
      }
    }
  }
};
</script>

